import React from 'react';
import styled from 'styled-components';

const LoadingIndicator = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

const LoadingIndicatorImage = styled.img`
  display: flex;
  width: 30px;
  height: 30px;
`;

export const LoadingIndicatorComponent = () => {
    return <LoadingIndicator><LoadingIndicatorImage src="/gif/loading.gif"/></LoadingIndicator>
}
